import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import * as _ from "lodash";
import { ToastService } from "ng-uikit-pro-standard";
import { FamiliaService } from "src/app/services/familia.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { RubroService } from "src/app/services/rubro.service";
import { TerritorioService } from "src/app/services/territorio.service";
import { VendedorService } from "src/app/services/vendedor.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { ConsoleService } from "src/app/shared/services/console.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { SecurityService } from "src/app/shared/services/security.service";
import { RutService } from "src/app/shared/services/rut.service";

@Component({
  selector: "app-territorios",
  templateUrl: "./territorios.component.html",
  styleUrls: ["./territorios.component.scss"],
  providers: [SecurityService]
})
export class TerritoriosComponent implements OnInit {
  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = "_RB_TIPO_VISTA_RESUMEN_"
  readonly RB_TIPO_VISTA_DETALLE: String = "_RB_TIPO_VISTA_DETALLE_"

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  private resumen_currentPayload: any = null
  resumen_loading: boolean = false
  resumen_listaMovimientos: Array<any> = null
  resumen_listaMovimientosAll: Array<any> = null
  resumen_paginationContext: PaginationContext = new PaginationContext()
  resumen_totales: any = null

  private detalle_currentPayload: any = null
  detalle_loading: boolean = false
  detalle_listaMovimientos: Array<any> = null
  detalle_listaMovimientosAll: Array<any> = null
  detalle_paginationContext: PaginationContext = new PaginationContext()
  detalle_totales: any = null

  optionsZona: Array<any> = [];
  optionsTerritorio: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsFamilia: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private vendedorService: VendedorService,
    private rubroService: RubroService,
    private familiaService: FamiliaService,
    private territorioService: TerritorioService,
    private rutService: RutService,
  ) {
    this.log = this.clog.log('REP. VTAS. TERRITORIOS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.resumen_paginationContext.RecordsByPage = 10
    this.detalle_paginationContext.RecordsByPage = 10

    this.loadZonas()
    this.loadRubros()
    this.loadTerritorios()

    this.createForm()
    this.formChangesSubscriptions()
  }

  loadZonas() {
    // this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
    //   const ok = respuesta !== null
    //   if (!ok) {
    //     this.messageRendererService.showErrors(mensajes)
    //     return
    //   }
    //   const { registros } = respuesta
    //   this.optionsZona = registros.map(vendedor => ({ value: vendedor.rut, label: vendedor.nombre, ...vendedor }))
    // })
  }

  private loadRubros() {
    this.rubroService.obtenerRubrosReporteVenta(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map(rubro => ({ value: rubro.codigo, label: rubro.descripcion, ...rubro }))
    })
  }

  private loadTerritorios() {
    this.territorioService.obtenerCombo({
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        tipobusqueda: 1
      }
    }, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta
      this.optionsTerritorio = registros.map(territorio => ({ value: territorio.codigo, label: territorio.descripcion, ...territorio }))
    })
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_RESUMEN, [Validators.required]],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      listaTerritorio: [[]],
      listaRubro: [[]],
      listaFamilia: [[]]
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("listaRubro").valueChanges.subscribe((rubro: string) => {
      this.onRubroSelect(rubro)
    })

    this.formHeader.get("tipoVista").valueChanges.subscribe((tipoVista: string) => {
      // if (tipoVista === this.RB_TIPO_VISTA_RESUMEN) {
      //   this.formHeader.get("vendedores").setValue([])
      // }
    })
  }

  onRubroSelect(ev) {
    this.optionsFamilia = []

    const listaRubros = this.formHeader.get('listaRubro').value
    if (!listaRubros) return

    for (let i = 0; i < listaRubros.length; i++) {
      this.loadFamilias(listaRubros[i])
    }
  }

  private loadFamilias(codigoRubro: Number) {
    this.familiaService.obtenerFamiliaxRubroReporteVenta(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map(p => ({ value: p.codigo, label: p.nombre }))
      this.optionsFamilia = this.optionsFamilia.concat(options)
    })
  }
  /********* BÚSQUEDA RESUMEN/DETALLE *********/
  buscar(pageNumber: number) {
    this.resumenBuscar(pageNumber)
    this.detalleBuscar(pageNumber)
  }
  /********* BÚSQUEDA RESUMEN/DETALLE *********/

  /********* RESUMEN *********/
  resumenBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.resumen_paginationContext.CurrentPage = pageNumber

    this.resumen_listaMovimientos = null
    this.resumen_listaMovimientosAll = null

    const { fechaDesde, fechaHasta, listaTerritorio, listaRubro, listaFamilia } = this.formHeader.value
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaTerritorio,
        listaRubro,
        listaFamilia,
      },
      paginaActual: this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.resumen_paginationContext.RecordsByPage
    }
    this.resumen_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.resumen_loading = true
    this.territorioService.obtenerReporteVentasTerritoriosResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.resumen_listaMovimientosAll = registros
      this.resumen_paginationContext.RecordsCount = this.resumen_listaMovimientosAll.length //totalRegistros
      this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage) //totalPaginas
      this.resumen_paginationContext.CurrentPage = 1

      this.resumen_loading = false
      this.showPageResumen(this.resumen_paginationContext.CurrentPage)
      this.calculateTotalesResumen()
    })
  }

  showPageResumen(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber
    const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage
    this.resumen_listaMovimientos = _.slice(this.resumen_listaMovimientosAll, start, start + this.resumen_paginationContext.RecordsByPage)
  }

  calculateTotalesResumen() {
    this.resumen_totales = {
      monto_neto: _.sumBy(this.resumen_listaMovimientosAll, 'monto_neto'),
      descuento: _.sumBy(this.resumen_listaMovimientosAll, 'descuento'),
      neto_total: _.sumBy(this.resumen_listaMovimientosAll, 'neto_total')
    }
  }

  resumenOnPageChange(context: PaginationContext) {
    // this.resumenBuscar(context.RequestedPage)
    this.showPageResumen(context.RequestedPage)
  }

  resumenDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.resumen_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.territorioService.obtenerReporteVentasTerritoriosResumenExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
  /********* RESUMEN *********/

  /********* DETALLE *********/
  detalleBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.detalle_paginationContext.CurrentPage = pageNumber

    this.detalle_listaMovimientos = []
    const { fechaDesde, fechaHasta, listaTerritorio, listaRubro, listaFamilia } = this.formHeader.value
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaTerritorio,
        listaRubro,
        listaFamilia,
      },
      paginaActual: this.detalle_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.detalle_paginationContext.RecordsByPage
    }
    this.detalle_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.detalle_loading = true
    this.detalle_listaMovimientos = null
    this.detalle_listaMovimientosAll = null

    this.territorioService.obtenerReporteVentasTerritoriosDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.detalle_loading = false
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.detalle_listaMovimientosAll = registros
      this.detalle_paginationContext.RecordsCount = this.detalle_listaMovimientosAll.length //totalRegistros
      this.detalle_paginationContext.PagesCount = Math.ceil(this.detalle_paginationContext.RecordsCount / this.detalle_paginationContext.RecordsByPage) //totalPaginas
      this.detalle_paginationContext.CurrentPage = 1
      this.detalle_listaMovimientosAll.forEach((mov, index) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      })
      this.showPageDetalle(this.detalle_paginationContext.CurrentPage)
      this.calculateTotalesDetalles()
      this.detalle_loading = false
    })
  }

  showPageDetalle(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber
    const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage
    this.detalle_listaMovimientos = _.slice(this.detalle_listaMovimientosAll, start, start + this.detalle_paginationContext.RecordsByPage)
  }

  calculateTotalesDetalles() {
    this.detalle_totales = {
      monto_neto: _.sumBy(this.detalle_listaMovimientosAll, 'monto_neto'),
      descuento: _.sumBy(this.detalle_listaMovimientosAll, 'descuento'),
      neto_total: _.sumBy(this.detalle_listaMovimientosAll, 'neto_total')
    }
  }

  detalleOnPageChange(context: PaginationContext) {
    // this.detalleBuscar(context.RequestedPage)
    this.showPageDetalle(context.RequestedPage)
  }

  detalleDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.detalle_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.territorioService.obtenerReporteVentasTerritoriosDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  LimpiarData(){
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader.reset();
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get("tipoVista").setValue(this.RB_TIPO_VISTA_RESUMEN)
    this.formHeader.get("listaTerritorio").setValue([])
    this.formHeader.get("listaRubro").setValue([])
    this.formHeader.get("listaFamilia").setValue([])
    this.resumen_listaMovimientos = null
    this.resumen_listaMovimientosAll = null
    this.detalle_listaMovimientos = null
    this.detalle_listaMovimientosAll = null
  }
}
